export const bucketColors = [
  '#ff0000',
  '#ffd000',
  '#c4fa9e',
  '#4fbbff',
  '#0000ff',
];

export const notRatedLegendItem = {
  label: 'Not rated or not available',
  hexCode: '#dcdcdc',
  max: null,
  min: null,
};

interface MapLegendOptions {
  max?: Nullable<number>;
  min?: Nullable<number>;
  // Add more options here...
}

const getValuesRange = (
  valuesMap: {
    [key: string]: Nullable<number>;
  },
  options?: MapLegendOptions,
) => {
  const values = Object.values(valuesMap).flatMap((v) =>
    v != null ? [v] : [],
  );
  if (!values.length) return [];
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  // Round min down to the nearest 10
  const roundedMin = Math.floor(minValue / 10) * 10;
  // Round max up to the nearest 10, ensuring range is at least 10
  const roundedMax =
    Math.ceil((maxValue + (minValue === maxValue ? 1 : 0)) / 10) * 10;
  // Use provided values for max/min from options, if given
  return [options?.min ?? roundedMin, options?.max ?? roundedMax];
};

export const getNumericMapLegend = (
  valuesMap: {
    [key: string]: Nullable<number>;
  },
  options?: MapLegendOptions,
) => {
  const [min, max] = getValuesRange(valuesMap, options);
  if (min == null) return [notRatedLegendItem];
  const valuesRange = max - min;
  const bucketSize = valuesRange / 5;
  return [
    ...bucketColors.map((hexCode, i) => {
      const bucketMin = min + bucketSize * i;
      const bucketMax = min + bucketSize * (i + 1);
      return {
        hexCode,
        label: `${bucketMin} - ${bucketMax}`,
        max: bucketMax,
        min: bucketMin,
      };
    }),
    notRatedLegendItem,
  ];
};
